import CardListMap from '../../Company/Payroll/Subcomponents/CardListMap';
import { IconClockTable, IconEquipment } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status } from '../../../../enums/statusEnum';
import EquipmentMaterialSectionApp from '../Functionality/EquipmentMaterialSectionApp';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import { DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat } from '../../../../Apis/functions';
import EquipmentMaterialModal from '../modal/EquipmentMaterialModal';
import MarkAsCompletedModal from '../modal/MarkAsCompletedModal';
import NotInformation from '../../../../components/NotInformation';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentMaterialSection = ({ contractorId }) => {
    const {
        t,
        selected,
        setSelected,
        searchId,
        setResults,
        results,
        searchElement,
        setSearchElement,
        setSearch,
        option,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        showModal,
        setShowModal,
        showMarkAsReadModal,
        setShowMarkAsReadModal,
        pagination,
        getActionsButtons,
        getData,
        markAsCompleted,
        setMarkAsCompleted,
    } = EquipmentMaterialSectionApp({ contractorId });

    return (
        <>
            <SearchSimple
                id={searchId}
                setSearchResults={setResults}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                page={page}
                rowsPerPage={rowsPerPage}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                label='search_by_name'
                contractorId={contractorId}
                setSearch={setSearch}
                callApi={() => getData(0, { searchElement })}
                resetApi={() => getData(0, { searchElement: '' })}
            />
            {results?.content.length > 0 ? (
                <>
                    {results?.content.map((item, index) => (
                        <CardListMap
                            key={item.id}
                            icon={<IconEquipment className='w-32px h-30px' />}
                            backgroundColor='background-shades-100'
                            classContainerIcon='h-56px w-56px background-warning-100'
                            colIcon='col-sm-2 col-md-1 p-3 p-md-0'
                            colBody='col-sm-10 col-md-11'
                            body={
                                <>
                                    <div className='row align-items-center ml-2'>
                                        <div className='col-6 d-flex align-items-center'>
                                            <div className='flex-grow-1 minw-0'>
                                                <CustomTooltip
                                                    text={item?.name}
                                                    classes={
                                                        'font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows ml-2'
                                                    }
                                                    showIfTruncated={true}
                                                    placement={'top'}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-6 d-flex justify-content-end'>
                                            {getActionsButtons(item, index)}
                                        </div>
                                    </div>

                                    <div className='row align-items-center justify-content-start ml-3'>
                                        <div className='col-6 col-md-8 d-flex align-items-center gap-2 mb-2 mb-md-0'>
                                            <IconClockTable className='icon-color-shades-500' />
                                            <p className='fs-14px font-color-shades-500 ibl-font-w-400 mb-0'>
                                                {t('last_activity')}:{' '}
                                                {item?.lastAccess
                                                    ? getDateFormat(
                                                          item.lastAccess,
                                                          false,
                                                          DATE_TIME_FORMAT_NAME_MODEL.shortMonth,
                                                      )
                                                    : EMPTY_VALUES.DEFAULT}
                                            </p>
                                        </div>
                                        <div className='col-6 col-md-4 d-flex justify-content-end justify-content-md-end'>
                                            <CustomChip
                                                background={statusColor[item.statusId]}
                                                fontColor={statusFontColor[item.statusId]}
                                                borderColor={statusBorderColor[item.statusId]}
                                                legend={t(status[item.statusId]) || EMPTY_VALUES.DEFAULT}
                                                className='border-radius-4px'
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        />
                    ))}

                    {pagination()}
                </>
            ) : (
                <NotInformation text={t('no_equipment_and_material')} card={true} />
            )}
            {showModal && (
                <EquipmentMaterialModal
                    show={showModal }
                    onClose={() => setShowModal(false)}
                    item={selected}
                    setItem={setSelected}
                    icon={<IconEquipment className='mr-8px mb-1 icon-color-general-950' />}
                    setShowMarkAsReadModal={setShowMarkAsReadModal}
                    markAsCompleted={markAsCompleted}
                />
            )}
            {showMarkAsReadModal && (
                <MarkAsCompletedModal
                    show={showMarkAsReadModal}
                    onHide={() => setShowMarkAsReadModal(false)}
                    equipment={selected}
                    onCompleted={() => {
                        setShowMarkAsReadModal(false);
                        setShowModal(true);
                    }}
                    setMarkAsCompleted={setMarkAsCompleted}
                />
            )}
        </>
    );
};

export default EquipmentMaterialSection;
